import type * as React from "react";
import {
  Sidebar as SidebarUI,
  SidebarRail,
} from "@/core/components/ui/sidebar";
import { useAuth } from "@/core/components/auth/store/auth";
import { WosSidebarHeader } from "./wos-sidebar-header";
import { WosSidebarMenu } from "./wos-sidebar-menu";
import { WosSidebarFooter } from "./wos-sidebar-footer";

export function WosSidebar({
  ...props
}: React.ComponentProps<typeof SidebarUI>) {
  const { userInfo } = useAuth();

  if (!userInfo || !userInfo.user) {
    return null;
  }

  return (
    <SidebarUI
      {...props}
      collapsible="icon"
      className="border-none font-body"
      data-testid="wos-sidebar"
    >
      <WosSidebarHeader />
      <WosSidebarMenu />
      <WosSidebarFooter />
      <SidebarRail />
    </SidebarUI>
  );
}
